import React from "react";

const HALLWAY =
  "https://customer-assets.emergentagent.com/job_school-printing-hub/artifacts/wc2zq3i0_StockCake-Busy_school_hallway-1333185-medium.jpg";
const ATHLETIC =
  "https://customer-assets.emergentagent.com/job_school-printing-hub/artifacts/dwh1yt3r_school-championship-banners.jpg";
const GRAD =
  "https://customer-assets.emergentagent.com/job_school-printing-hub/artifacts/io3nqas3_OVAL_Grad-Door-Banners-20212.webp";
const CLASSROOM =
  "https://customer-assets.emergentagent.com/job_school-printing-hub/artifacts/a7p1pl3p_Students-Using-Posters-Created-with-a-School-Poster-Maker.webp";
const EVENT =
  "https://customer-assets.emergentagent.com/job_school-printing-hub/artifacts/46k2nwlq_IMG_6572.jpg";
const SIGNAGE =
  "https://customer-assets.emergentagent.com/job_school-printing-hub/artifacts/gtwh0teu_School-Hallway-Values-Posters-Created-with-a-School-Poster-Maker.webp";
const RECOGNITION =
  "https://customer-assets.emergentagent.com/job_school-printing-hub/artifacts/gtwh0teu_School-Hallway-Values-Posters-Created-with-a-School-Poster-Maker.webp";
const PTO =
  "https://images.unsplash.com/photo-1760992004210-44a502a2872d?fm=webp&q=80&w=1200&fit=crop";

const TILES = [
  { title: "Hallway posters", img: HALLWAY, span: "md:col-span-4 lg:col-span-4 lg:row-span-2 min-h-[300px] lg:min-h-[420px]" },
  { title: "Event banners", img: EVENT, span: "md:col-span-4 lg:col-span-4 min-h-[220px]" },
  { title: "School signage", img: SIGNAGE, span: "md:col-span-2 lg:col-span-2 min-h-[200px]" },
  { title: "Classroom visuals", img: CLASSROOM, span: "md:col-span-2 lg:col-span-2 min-h-[200px]" },
  { title: "Athletic displays", img: ATHLETIC, span: "md:col-span-2 lg:col-span-3 min-h-[260px]" },
  { title: "Student recognition boards", img: RECOGNITION, span: "md:col-span-2 lg:col-span-3 min-h-[260px]" },
  { title: "Graduation & ceremony materials", img: GRAD, span: "md:col-span-2 lg:col-span-3 min-h-[240px]" },
  { title: "PTO / fundraiser graphics", img: PTO, span: "md:col-span-2 lg:col-span-3 min-h-[240px]" },
];

export default function WhatYouCreate() {
  return (
    <section
      data-testid="what-you-create-section"
      className="bg-[#F4F6F4] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-16 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            What's possible
          </div>
          <h2
            data-testid="what-you-create-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            What Schools Are Creating Every Day
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-8 gap-4 md:gap-5 auto-rows-min">
          {TILES.map((t, i) => (
            <div
              key={t.title}
              data-testid={`create-tile-${i}`}
              className={`relative group overflow-hidden rounded-2xl bg-slate-200 ${t.span} col-span-1`}
            >
              <img
                src={t.img}
                alt={t.title}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/95 via-navy/40 to-transparent" />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
              <div className="relative h-full flex flex-col justify-end p-5 md:p-6">
                <span className="inline-block text-[10px] uppercase tracking-[0.18em] font-bold text-teal mb-2">
                  In-house print
                </span>
                <h3 className="font-serif text-lg md:text-xl lg:text-2xl font-bold text-white leading-snug">
                  {t.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
